module.exports = __webpack_public_path__ + "static/media/small.941b1bee.jpg";